import { z } from "zod";

export const PosaChargeInputSchema = z.object({
  code: z.string().length(10, { message: "10桁のコードを入力してください" }),
});

export type PosaChargeInputSchemaValue = z.infer<typeof PosaChargeInputSchema>;
